import { Injectable } from '@angular/core';
import { MeasureCard } from '@pages/control-page/control-page-main/control-page-compare/cp-compare-sidebar/cp-compare-sidebar.service';

@Injectable()
export class CpCompareSidebarColorsService {

  private remainingColors = [
    '--blue',
    '--amnesty-purple',
    '--see-green',
    '--salmon-pink',
  ];

  getColor(measureCard: MeasureCard) {
    return measureCard.color ?? this.remainingColors.shift();
  }

  releaseColor(measureCard: MeasureCard) {
    if (measureCard.color) {
      this.remainingColors.push(measureCard.color);
      delete measureCard.color;
    }
  }
}